import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { Guid } from 'guid-typescript';
import { Observable } from 'rxjs';
import { CommonService } from '../common/common.service';

@Injectable({
  providedIn: 'root',
})
export class AuditReportService {
  constructor(private http: HttpClient, private commonService: CommonService) {}

  saveAuditDetails(audit: any[]): Observable<any> {
    const headers = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http.post<any>(`${environment.apiVersionUrl}Audit/saveAuditDetails`, this.commonService.trimObjectSpace(JSON.stringify(audit)), headers);
  }

  getAllAuditDetails(): Observable<any> {
    return this.http.get<any>(`${environment.apiVersionUrl}Audit/getAllAuditDetails`);
  }

  getAudit(): Observable<any> {
    return this.http.get<any>(`${environment.apiVersionUrl}Audit/getAuditDetails`);
  }

  getAuditBasedonId(AuditId: Guid): Observable<any> {
    return this.http.get<any>(`${environment.apiVersionUrl}Audit/getAuditDetailsById?Id=${AuditId}`);
  }

  getAuditReportDetailsByType(type: any): Observable<any> {
    return this.http.get<any>(`${environment.apiVersionUrl}Audit/getAuditReportDetailsByType?audittype=${type}`);
  }

  saveAuditReportDetails(report: any): Observable<any> {
    const headers = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http.post<any>(`${environment.apiVersionUrl}Audit/saveAuditReportDetails`, this.commonService.trimObjectSpace(JSON.stringify(report)), headers);
  }

}
